import React from 'react';

const DayPopup = ({ date, events, onClose }) => {
  const formatTime = (timeStr) => {
    const [hour, minute] = timeStr.split(':').map(Number);
    const suffix = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12}:${minute.toString().padStart(2, '0')} ${suffix}`;
  };

  return (
    <div className="day-popup-overlay" role="presentation" onClick={onClose}>
      <div className="day-popup" role="dialog" aria-modal="true" aria-labelledby="day-popup-title" onClick={(event) => event.stopPropagation()}>
        <h2 id="day-popup-title">Events for {date}</h2>
        {events.map((event, i) => (
          <div key={i} className="day-popup-event">
            <h3 style={{ color: event.color }}>{event.title}</h3>
            <p><em>{formatTime(event.time)}</em></p>
            <p>{event.description}</p>
          </div>
        ))}
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default DayPopup;
